const Toppings = () => {
  return (
    <section className="toppings">
      <br />
      <label for="topping">
        <strong>What toppings would you like?</strong>
      </label>
      <br />
      <br />
      <div className="checkboxes">
        <input
          className="lettuce"
          name="topping"
          type="checkbox"
          value="lettuce"
        ></input>
        <label for="lettuce">Lettuce</label>
        <input
          className="tomato"
          name="topping"
          type="checkbox"
          value="tomato"
        ></input>
        <label for="tomato">Tomato</label>
        <input
          className="pickles"
          name="topping"
          type="checkbox"
          value="pickles"
        ></input>
        <label for="pickles">Pickles</label>
        <input
          className="onion"
          name="topping"
          type="checkbox"
          value="onion"
        ></input>
        <label for="onion">Onion</label>
        <input
          className="mushrooms"
          name="topping"
          type="checkbox"
          value="mushrooms"
        ></input>
        <label for="mushrooms">Mushrooms</label>
        <input
          className="chili-peppers"
          name="topping"
          type="checkbox"
          value="chili peppers"
        ></input>
        <label for="chili peppers">Chili Peppers</label>
        <input
          className="jalapeno"
          name="topping"
          type="checkbox"
          value="jalapeno"
        ></input>
        <label for="jalapeno">Jalapenos</label>
        <input
          className="carmalized-onions"
          name="topping"
          type="checkbox"
          value="carmalized-onions"
        ></input>
        <label for="carmalized onions">Carmalized Onions</label>
        <input
          className="sauerkraut"
          name="topping"
          type="checkbox"
          value="sauerkraut"
        ></input>
        <label for="sauerkraut">Sauerkraut</label>
        <input
          className="bacon"
          name="topping"
          type="checkbox"
          value="bacon"
        ></input>
        <label for="bacon">Bacon</label>
        <input
          className="fried-egg"
          name="topping"
          type="checkbox"
          value="fried-egg"
        ></input>
        <label for="fried egg">Fried Egg</label>
      </div>
      <br />
      <br />
    </section>
  );
};

export default Toppings;
